import React, { Component, useEffect, useState } from 'react'
import '../../App.css'
import { Container, Row, Col } from 'react-bootstrap'
import Axios from 'axios'
import ReactTooltip from 'react-tooltip'
import { formatZARCurrency } from '../../MoneyFormat'
import { API_URL } from '../../config'

const Breakdown = (props) => {
  const [tickets, setTickets] = useState([])
  const [ticketType, setTicketType] = useState('')
  const [qty, setQty] = useState(0)
  const [gross, setGross] = useState(0)
  const [platformFee, setPlatformFee] = useState(0)
  const [ticketPrice, setTicketPrice] = useState(0)

  useEffect(() => {
    const event_id = props.eventid
    const businessid = localStorage.getItem('businessid')
    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=BREAKDOWNSALES&businessid=${businessid}&event_id=${event_id}`,
      {
        withCredentials: true,
      }
    )
      .then((response) => {
        if (response.data.error == 1) {
          setTickets([])
          // setTicketType(0);
          // setQty(0);
          // setGross(0);
          // setPlatformFee(0);
          // setTicketPrice(0);
        } else {
          setTickets(response.data)
          // setTicketType(response.data[0].ticket_type);
          // setQty(response.data[0].qty);
          // setGross(response.data[0].total_gross);
          // setPlatformFee(response.data[0].platformFee);
          // setTicketPrice(response.data[0].ticket_price);
        }
      })
      .catch((error) => console.log(error))
  }, [props.location, props.count])

  const totalQty =
    tickets.length > 0 ? tickets.reduce((sum, item) => sum + parseFloat(item.qty), 0) : 0

  const totaAdmission =
    tickets.length > 0 ? tickets.reduce((sum, item) => sum + parseFloat(item.admission), 0) : 0

  const totalGross =
    tickets.length > 0 ? tickets.reduce((sum, item) => sum + parseFloat(item.total_gross), 0) : 0

  const formattedGross =
    tickets.length > 0
      ? totalGross.toLocaleString('en-ZA', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : 0

  return (
    <>
      <div className="col-12 mt-2 p-0">
        <div className="item-list w-100">
          <label className="ticket-title  pl-0 pr-0">
            <h5>Revenue by ticket type</h5>
          </label>
        </div>
      </div>

      <div className="col-12 p-0">
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th className="td-bottom-line-map">Type</th>
                {/* <th className="td-bottom-line-map">Price per Ticket</th> */}
                <th className="td-bottom-line-map">Tickets Sold</th>
                <th className="td-bottom-line-map">Admissions</th>
                <th className="td-bottom-line-map">Revenue</th>
              </tr>
            </thead>
            <tbody>
              {tickets.length == 0 ? (
                <div className="col-12 text-left p-2 text-grey">No data as yet</div>
              ) : (
                tickets.map((item, index) => (
                  <tr key={index}>
                    <td className="td-bottom-line-map">{item.ticket_type}</td>
                    {/* <td className="td-bottom-line-map">R{item.ticket_price}</td> */}
                    <td className="td-bottom-line-map">{item.qty}</td>
                    <td className="td-bottom-line-map">{item.admission}</td>
                    <td className="td-bottom-line-map">
                      {formatZARCurrency(item.total_gross.toString())}
                    </td>
                  </tr>
                ))
              )}
              <tr>
                <td></td>
                <td className="text-left">
                  <span>Total:</span> {totalQty}
                </td>

                <td className="text-left">
                  <span>Total:</span> {totaAdmission}
                </td>
                <td className="text-left">
                  <span>Total:</span> R{formattedGross}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <ReactTooltip id="budgetTip" place="top" type="dark" effect="solid" />
      </div>
    </>
  )
}

export default Breakdown
